import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useRequiresAuthorization } from '@ibk/shared-permissioning';
import { TranslationProvider } from '@ibk/shared-translation';
import { OperatorDrawerNavs, OperatorRoles, PermissionsDomains, PermissionsResources } from '@ibk/shared-types';
import { sharedLayoutTranslations } from '../../../../translations';
import { OperatorsList } from '../../components/OperatorsList';
import { useOperatorsList } from '../../hooks/useOperatorList';
const OperatorDrawerHome = ({ ...props }) => {
    const { operatorsList, isLoading, isRefetching, deleteOperator, confirmationModal } = useOperatorsList();
    const canEdit = useRequiresAuthorization(PermissionsDomains.AUTHORIZATION, PermissionsResources.AUTHORIZATION_EDIT_OPERATOR);
    return (_jsxs(TranslationProvider, { translations: sharedLayoutTranslations, defaultLanguage: 'pt-BR', children: [_jsx(OperatorsList, { operatorsList: operatorsList, isLoading: isLoading, isRefetching: isRefetching, onDeleteOperator: deleteOperator, onEditOperator: canEdit
                    ? ({ partyId, name }) => {
                        if (!partyId)
                            return;
                        props.handleGoTo(OperatorDrawerNavs.EDIT_OPERATOR, {
                            role: OperatorRoles.OPERATOR,
                            operatorPartyId: partyId,
                            operatorName: name,
                        });
                    }
                    : undefined, goToRegister: () => props.handleGoTo(OperatorDrawerNavs.REGISTER_TYPE) }), confirmationModal] }));
};
export default OperatorDrawerHome;
